module.exports = __webpack_public_path__ + "img/web1icon1.e95845f2.png";